import React from 'react'
import '../styles/Input.css'

interface InputProps {
  value: string
  type: string
  changeValue: (value: string) => void
  label: string
  placeholder: string
  onBlur?: () => void
  className?: string
}

const Input: React.FC<InputProps> = props => {
  return (
    <div className="w-full">
      <input
        type={props.type}
        placeholder={props.placeholder}
        value={props.value}
        onChange={e => props.changeValue(e.target.value)}
        onBlur={props.onBlur}
        required
        className={`w-full bg-transparent text-white placeholder-gray-400 px-4 py-2 border ${
          props.className || ''
        }`}
      />
    </div>
  )
}

export default Input
